import { H4, H5, Image, LI, UL } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { RegisterWizadListProp } from "../../../../Type/Pages";
import { REGISTER_STEP_DATA } from "../../../../Data/Pages";

export const RegisterWizadList = ({ level }: RegisterWizadListProp) => {
  return (
    <UL className="simple-list theme-scrollbar anchor">
      <LI>
        <Link className="logo text-start ps-0" to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage" body={true} />
          <Image className="for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage" body={true} />
        </Link>
      </LI>
      {REGISTER_STEP_DATA.map((data, index) => (
        <LI key={index}>
          <Link to={`#form-${index}`} className={`${level === index + 1 ? "selected" : level > index + 1 ? "done" : "disabled"}`}>
            <H4>{index + 1}</H4>
            <H5>
              {data.tittle}
              {data.tittle === "Done" ? <i className="fa fa-thumbs-o-up ms-1" /> : " "}
            </H5>
            <small>{data.detail}</small>
          </Link>
        </LI>
      ))}
      <LI>
        <Image src={dynamicImage(`login/icon.png`)} alt="looginpage" />
      </LI>
    </UL>
  );
};
